export { default } from './BillingList.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingList/index.js